import React, { useEffect, useState } from 'react';
import PropTypes from 'prop-types';
import dayjs from 'dayjs';
import relativeTime from 'dayjs/plugin/relativeTime';
import api from '../../../context/api';
import styles from './Listing.module.scss';
import Loader from '../../../common/Loader/Loader';
import { ReactComponent as Clock } from './clock.svg';

dayjs.extend(relativeTime);

const ListingContainer = ({ message }) => {
  const [loading, setLoading] = useState(true);
  const [listing, setListing] = useState({});
  const {
    headline,
    images,
    category_name,
    display_price,
    address,
    bedrooms,
    bathrooms,
    floor_area,
    land_area,
    floor_level,
    created_at,
    url,
  } = listing;

  const getListing = async () => {
    const response = await api.get(`/listing/${message}`).then(response => response.data);
    setListing(response);
    setLoading(false);
  };

  useEffect(() => {
    getListing();
  }, []);

  const loadingRenderer = () => <Loader> Loading</Loader>;
  const defaultPhoto = '/photo';

  return (
    <a href={`${url}`} rel="noopener noreferrer" target="_blank">
      <div className={styles.listingContainer}>
        {loading && loadingRenderer}
        <div className={styles.listingCard}>
          <div className={styles.listingHeading}>{headline}</div>
          <div
            className={styles.imageContainer}
            style={{
              backgroundImage: `url(${images && images[0] ? images[0].url : defaultPhoto})`,
            }}
          />
          <div className={styles.listingCardBody}>
            <div className={styles.listingCardBodyTop}>
              <h3>{category_name}</h3>
              <div className={styles.price}>{display_price}</div>
            </div>
            <div className={styles.listingDetails}>
              {!!bedrooms && (
                <>
                  <span className={styles.listingDetail}>
                    <span className="icon-bed" />
                    {bedrooms}
                  </span>
                </>
              )}
              {!!bathrooms && (
                <>
                  <span className={styles.listingDetail}>
                    <span className="icon-bath" />
                    {bathrooms}
                  </span>
                </>
              )}
              {!!floor_area && (
                <>
                  <span className={styles.listingDetail}>
                    <span className="icon-floorarea" />
                    {floor_area}
                  </span>
                </>
              )}
              {!!land_area && (
                <>
                  <span className={styles.listingDetail}>
                    <span className="icon-landarea" />
                    {land_area}
                  </span>
                </>
              )}
            </div>
            <div className={styles.address}>
              <span>
                <i className="icon-marker-left" />
                {address}
              </span>
            </div>
            <div className={styles.time}>
              <span>
                <Clock />
                Listed: {dayjs(created_at).fromNow()}
              </span>
            </div>
          </div>
        </div>
      </div>
    </a>
  );
};

ListingContainer.propTypes = {
  message: PropTypes.string.isRequired,
};

export default ListingContainer;
